import { atom } from 'recoil'
import { IEvent } from './events.types'

interface IEventsAtomState {
  items: IEvent[]
}

const eventsAtom = atom<IEventsAtomState>({ key: 'events', default: { items: [] } })
export default eventsAtom
